import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { CompanyToDoProgressInfoDto } from "../../pages/ToDo/ToDoList/schema/to-do";
import { companyToDoProgressApi } from "./company-to-do-progress.api";

const initialState: CompanyToDoProgressInfoDto[] = [];

export const companyToDoProgressSlice = createSlice({
	name: "company-to-do-progress",
	initialState,
	reducers: {
		updateToDo: (state, action: PayloadAction<CompanyToDoProgressInfoDto[]>) => {
			return action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			companyToDoProgressApi.endpoints.getCompanyToDos.matchFulfilled,
			(state, { payload }) => {
				return payload ?? [];
			}
		);
	},
});

export const { updateToDo } = companyToDoProgressSlice.actions;
export const companyToDoProgressReducer = companyToDoProgressSlice.reducer;
export const companyToDoProgressSelector = (state: RootState) =>
	state[companyToDoProgressSlice.name];
